import Spinner, { Props as SpinnerProps } from "@storeblocks/loading-indicator";

import React from "react";
import { useBrandingTheme } from "Store/partners/partnerHooks";

interface Props extends Omit<SpinnerProps, "color"> {
  id?: string;
  black?: boolean;
}

export const ThemedSpinner = ({
  id,
  black,
  size,
  ...rest
}: Props): React.ReactElement => {
  const theme = useBrandingTheme();
  const color = black ? "on-background" : theme.spinner;

  return <Spinner id={id} color={color} size={size} {...rest} />;
};
